import Model, { attr } from '@ember-data/model';

export default class UserModel extends Model {
  @attr('string') firstName!: string;
  @attr('string') lastName!: string;
  @attr('string') email!: string;
  @attr('string') role!: string;
  @attr('string') selectedFundId?: string;
  @attr('boolean') hasMultipleFunds!: boolean;
  @attr('boolean') hasMultipleCoachingIndividuals!: boolean;
  @attr('boolean') coachingOnly!: boolean;
  @attr('string') afterLoginRoute?: string;
  @attr('boolean') stripeIsDelinquent!: boolean;
  @attr('string') organizationId!: string;
  @attr('string') organizationName!: string;

  get name() {
    return `${this.firstName} ${this.lastName}`;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    user: UserModel;
  }
}
